export const ROLES = {
  admin: {
    label: "Admin",
    role: "a2470ee4",
    fields: ["username", "password", "email"],
  },
  user: {
    label: "Usuario",
    role: "nravb346b",
    fields: ["name", "surname", "phone", "password", "email"],
  },
  lawyer: {
    label: "Abogado",
    role: "q3ct6yn8",
    fields: ["name", "surname", "specialties", "phone", "password", "email", "about", "college_number"],
  },
};

export const ROLES_RAW = Object.values(ROLES).map((r) => r.role);

export const ROLE_OPTS = Object.values(ROLES).map((r) => ({
  label: r.label,
  value: r.role,
}));
